import React, { useState } from "react";
import {
  checkTommorow,
  isEmptyOrNull,
  isNotEmptyOrNull,
} from "../../../utils/common-utils";
import { Box, Button, Image, Text } from "@chakra-ui/react";
import {
  getTaskType,
  getTaskTypeIcons,
  TaskStatus,
} from "../../../utils/accordion/accordionHelper";
import accordion_images from "../../../utils/accordion/accordion_images";
import CustomToolTip from "../../atoms/chakraHelpers/customToolTip";

const SubtopicsAccordionMobile = ({
  item,
  onClick,
  setTaskType,
  isChapterEndAssessment,
  index,
}) => {
  const [isIconHover, setIsIconHover] = useState(false);
  const handleHoverChange = (hoverStatus) => {
    setIsIconHover(hoverStatus);
  };
  let isLevelUpTask = item?.levelUpReference;
  let hasReminder = item?.reminder;
  let hasAppreciation = item?.appreciation;
  let isAdvanced =
    item?.taskAttributes?.proficiencyLevel === "advanced" ? true : false;
  return (
    <Box
      display={"flex"}
      // height={"50px"}
      flexWrap={"wrap"}
      width={"240px"}
      _hover={{
        backgroundColor: "#FFDFDB",
      }}
      borderRadius={"4px"}
      onClick={() => {
        let onClickTaskType =
          item?.createdBy === "student" ? "Self Learn" : item?.taskType;
        setTaskType(item?.taskType);
        onClick(onClickTaskType, isChapterEndAssessment, index, item?.taskType);
      }}
      //marginLeft={"32px"}
      marginBottom={"4px"}
      padding={"4px"}
      //paddingLeft={"32px"}
      alignItems={"center"}
      gap={"4px"}
    >
      {/* DUE DATE */}
      <Box
        fontFamily={"Poppins, Text-xs/Regular"}
        fontWeight={"500"}
        fontSize={"10px"}
        lineHeight={"18px"}
        color={"#929292"}
      >
        {checkTommorow(item?.updatedAt, false, false)}
      </Box>
      {/* TASK STATUS */}
      <Box
        fontFamily={"Poppins, Text-xs/Regular"}
        fontWeight={"400"}
        fontSize={"12px"}
        lineHeight={"18px"}
        color={"#6D6BAE"}
      >
        {TaskStatus(item?.taskStatus)} :{" "}
      </Box>
      {/* TASK TYPE */}
      <Box
        display={"flex"}
        gap={"4px"}
        alignItems={"center"}
        marginRight={getTaskType(item?.taskType) === "Learn" ? "32px" : "0px"}
      >
        <Image
          src={getTaskTypeIcons(item?.taskType)}
          width={"16px"}
          height={"16px"}
        />
        <Text
          fontFamily={"Poppins, Text-xs/Regular"}
          fontWeight={"400"}
          fontSize={"12px"}
          lineHeight={"18px"}
          color={"#6D6BAE"}
        >
          {getTaskType(item?.taskType)}
        </Text>
      </Box>
      {/* CREATED BY */}
      <Box
        borderRadius={"8px"}
        // opacity="0.5"
        backgroundColor={
          item?.taskStatus === "completed"
            ? "#C5F2C7"
            : item?.taskStatus === "inProgress"
            ? "#FEFAE6"
            : "	#D3D3D3"
        }
        padding={item?.createdBy === "teacher" ? "4px 8px" : "4px 10px"}
        fontFamily={"Poppins, Text-xs/Semibold"}
        fontWeight={"600"}
        fontSize={"12px"}
        lineHeight={"18px"}
        color={
          item?.taskStatus === "completed"
            ? "#155D18"
            : item?.taskStatus === "inProgress"
            ? "#F59E0B"
            : "grey"
        }
      >
        {item?.createdBy === "teacher" ||
        isNotEmptyOrNull(item?.levelUpReference)
          ? "HW"
          : "Self"}
      </Box>
      {/* ADDITIONAL BUTTONS */}
      {isChapterEndAssessment &&
        (isAdvanced ? (
          <CustomToolTip
            icon={accordion_images.advanced}
            data={"This is Advanced Level"}
            variant={"AdvancedAccordion"}
          />
        ) : (
          <CustomToolTip
            icon={accordion_images.proficiency}
            data={"This is Proficient Level"}
            variant={"ProficientAccordion"}
          />
        ))}

      {isLevelUpTask && (
        <CustomToolTip
          icon={accordion_images.levelUp}
          data={"Teacher has asked you to Level-up on this Homework."}
          variant={"LevelUpAccordion"}
        />
      )}
      {hasReminder && (
        <CustomToolTip
          icon={accordion_images.reminder}
          data={"Your teacher sent a Reminder. Let's stay on track."}
          variant={"ReminderAccordion"}
        />
      )}
      {hasAppreciation && (
        <CustomToolTip
          icon={accordion_images.appreciation}
          data={"Your teacher appreciates your effort. Keep it up."}
          variant={"AppreciationAccordion"}
        />
      )}
    </Box>
  );
};

export default SubtopicsAccordionMobile;
